import React, { useState, useEffect } from 'react';
import { api } from '../utils/apiClient';
import { useAuth } from '../contexts/AuthContext';

const ProcessingStats = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [stats, setStats] = useState(null);
  const { isAdmin } = useAuth();

  useEffect(() => {
    if (isAdmin()) fetchStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin]);

  useEffect(() => {
    const handleAnalyticsFetch = () => { if (isAdmin()) fetchStats(); };
    window.addEventListener('triggerAnalyticsFetch', handleAnalyticsFetch);
    return () => window.removeEventListener('triggerAnalyticsFetch', handleAnalyticsFetch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin]);

  const fetchStats = async () => {
    if (!isAdmin()) {
      setError('You do not have permission to view statistics');
      setLoading(false);
      return;
    }
    try {
      const response = await api.getStats();
      if (response.data.success) {
        setStats(response.data.stats);
        setError('');
      } else {
        setError(response.data.error || 'Failed to fetch stats');
      }
    } catch (err) {
      console.error('Error fetching stats:', err);
      if (err.response?.status === 401) setError('Authentication failed - please refresh the page.');
      else if (err.response?.status === 403) setError('You do not have permission to view statistics');
      else setError('Unable to connect to analytics service');
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => { setLoading(true); fetchStats(); };

  if (!isAdmin()) return null;

  const total = (stats?.total_files_processed ?? stats?.total_files ?? 0).toLocaleString();
  const phf = (stats?.phf_files_processed ?? stats?.phf_files ?? 0).toLocaleString();
  const post = (stats?.post_files_processed ?? stats?.post_files ?? 0).toLocaleString();

  return (
    <section className="block">
      <div className="section-head">
        <h2><i className="fas fa-chart-simple"></i> File processing counter</h2>
        <button className="btn btn-ghost btn-sm" onClick={handleRefresh} disabled={loading}>
          <i className={`fas fa-rotate ${loading ? 'fa-spin' : ''}`}></i> Refresh
        </button>
      </div>
      {error ? (
        <div className="card card-pad"><span className="text-danger"><i className="fas fa-triangle-exclamation me-2"></i>{error}</span></div>
      ) : (
        <div className="tiles">
          <div className="tile accent">
            <i className="fas fa-folder-open t-ic"></i>
            <div className="t-num">{loading ? '…' : total}</div>
            <div className="t-lab">Total files processed</div>
          </div>
          <div className="tile">
            <i className="fas fa-user-tie t-ic"></i>
            <div className="t-num">{loading ? '…' : phf}</div>
            <div className="t-lab">PHF files</div>
          </div>
          <div className="tile">
            <i className="fas fa-briefcase t-ic"></i>
            <div className="t-num">{loading ? '…' : post}</div>
            <div className="t-lab">Position descriptions</div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ProcessingStats;
